import React from "react";
import classNames from "classnames";
import moment from "moment";
import {
  currencyFormatter,
  capitalizeFirstLetter,
  calculateDiscount,
} from "./../../utils/display";

export default ({
  currentPage,
  card,
  payments,
  order,
  openSupportCardLevelModal,
  orderSupportInfoCommon,
  renderCardHelpButtons,
}) => {
  const merchantName = card.merchantName;
  const merchantUrl = card.merchantImage;
  const cardNumber = card.number ? `xxxx${card.number}` : "N/A";
  const faceValue =
    !isNaN(parseFloat(card.faceValue)) && Object.keys(payments).length
      ? Number(card.faceValue)
      : Number(card.enteredValue);
  let deductionsMessages;
  let discrepancyMessage;
  let cardNotReceivedMessage;
  let newCardMessage;

  if (card.deductions && card.deductions.length) {
    deductionsMessages = card.deductions.map(({ id, amount }) => (
      <tr>
        <td colSpan="8" className="card-info-alert alert-text">
          This card has a deduction of {currencyFormatter(amount)}.{" "}
          <strong>Deduction ID: </strong> {id}
        </td>
      </tr>
    ));
  }

  if (
    card.faceValue &&
    card.faceValue !== card.enteredValue &&
    !card.newCard &&
    Object.keys(payments).length
  ) {
    discrepancyMessage = `This card was originally entered at ${currencyFormatter(
      card.enteredValue
    )}, but was verified for ${currencyFormatter(card.faceValue)}.`;
  }

  if (card.type !== "ecode" && card.receivedAt === "0000-00-00 00:00:00") {
    cardNotReceivedMessage = "This card was not yet received.";
  }

  if (card.newCard) {
    newCardMessage = "This card was not part of the original order.";
  }

  const cardRowClasses = classNames("acct-border-btm", {
    "no-border-btm":
      discrepancyMessage || cardNotReceivedMessage || newCardMessage,
  });

  const cardTableClasses = classNames("card-group-row", {
    "reset-headings": renderCardHelpButtons,
  });

  return (
    <tbody className={cardTableClasses}>
      <tr className={cardRowClasses}>
        <td className="hide-sm">
          <img src={merchantUrl} className="acct-responsive-img" />
        </td>
        <td className="card-contents-sm-screen">
          <strong>{merchantName ? merchantName : "N/A"}</strong>
        </td>
        <td className="card-contents-sm-screen">
          <span>{card.internalId}</span>
        </td>
        <td className="card-contents-sm-screen">
          <span>{card.refID ? card.refID : "N/A"}</span>
        </td>
        <td className="card-contents-sm-screen">
          <span>{cardNumber}</span>
        </td>
        <td className="card-contents-sm-screen">
          <span>{currencyFormatter(faceValue)}</span>
        </td>
        <td className="card-contents-sm-screen">
          {capitalizeFirstLetter(card.type)}
        </td>
        <td className="card-contents-sm-screen">
          <span>
            {currencyFormatter((Number(card.sellPercentage) / 100) * faceValue)}
          </span>
        </td>
      </tr>
      {deductionsMessages &&
        deductionsMessages.length > 0 &&
        deductionsMessages}
      {discrepancyMessage && (
        <tr>
          <td colSpan="8" className="card-info-alert alert-text">
            {discrepancyMessage}
          </td>
        </tr>
      )}
      {cardNotReceivedMessage && (
        <tr>
          <td colSpan="8" className="card-info-alert alert-text">
            {cardNotReceivedMessage}
          </td>
        </tr>
      )}
      {newCardMessage && (
        <tr>
          <td colSpan="8" className="card-info-alert alert-text">
            {newCardMessage}
          </td>
        </tr>
      )}
    </tbody>
  );
};
